import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from "@air/primitive-tooltip";
import { memo } from "react";
import { CustomField } from "~/components/CustomField";
import { PAGE_CONTENT_HEADER_MAX_WIDTH } from "~/components/PageHeader/constants";
import { BOARD_BLURB_CUSTOM_FIELDS } from "~/constants/testIDs";
import { getFlattenedCustomFieldValues } from "~/utils/CustomFields";
export const BoardBlurbCustomFields = /*#__PURE__*/ memo((param)=>{
    let { onPanelClick, customFields } = param;
    if (!(customFields === null || customFields === void 0 ? void 0 : customFields.length)) return null;
    const fieldsToRender = getFlattenedCustomFieldValues({
        customFields
    });
    if (!fieldsToRender.length) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": BOARD_BLURB_CUSTOM_FIELDS,
        className: "flex flex-wrap gap-2",
        style: {
            maxWidth: PAGE_CONTENT_HEADER_MAX_WIDTH
        },
        children: fieldsToRender.map((field)=>/*#__PURE__*/ _jsx(Tooltip, {
                label: field.fieldName,
                children: /*#__PURE__*/ _jsx(CustomField, {
                    className: !!onPanelClick ? "cursor-pointer" : "",
                    field: field,
                    onClick: onPanelClick,
                    shape: "rectangular",
                    size: "medium"
                })
            }, field.id))
    });
});
BoardBlurbCustomFields.displayName = "BoardBlurbCustomFields";
